import { useNotificationsLive } from '@/hooks/useNotifications'

/**
 * AF-134 — visually-hidden aria-live region that announces new
 * notifications to screen readers. Mounted once at the app root.
 *
 * The hook also fires sonner toasts for critical events; this component
 * is purely the a11y surface.
 */
export function NotificationsLive() {
  const { liveText } = useNotificationsLive()
  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className="sr-only"
    >
      {liveText}
    </div>
  )
}
